import { c as _c } from "react/compiler-runtime";
import React from "react";
import { SiteNavMobileCategory } from "trimble-terra/SiteNav";
import PersonalizationExperience from "../Personalization/PersonalizationExperience";
// import { formatNavCategory } from "./FormatNavCategory"
import Link from "next/link";
const PersonalizedMobileNavigationCategory = props => {
  const $ = _c(21);
  const data = props?.value;
  const passthroughProps = props?.value?.passthroughProps;
  const t0 = passthroughProps?.handleOpenNavItem;
  const t1 = passthroughProps?.openTopLevelMobileItem;
  const t2 = passthroughProps?.openSecondLevelMobileItem;
  const t3 = passthroughProps?.setOpenSecondLevelMobileItem;
  const t4 = data?.navItem?.backText || "Back";
  const t5 = passthroughProps?.closeAllMenus;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[0] !== data?.navItem || $[1] !== t0 || $[2] !== t1 || $[3] !== t2 || $[4] !== t3 || $[5] !== t4 || $[6] !== t5) {
    const passthroughPropsMobileNav = {
      LinkComponent: Link,
      handleOpenNavItem: t0,
      openTopLevelMobileItem: t1,
      openSecondLevelMobileItem: t2,
      setOpenSecondLevelMobileItem: t3,
      backText: t4,
      closeAllMenus: t5
    };
    t7 = data?.navItem;
    t8 = passthroughPropsMobileNav;
    t9 = Link;
    t6 = formattedNavCategoryExperiences(data?.navItem?.ntExperiencesCollection?.items, passthroughPropsMobileNav);
    $[0] = data?.navItem;
    $[1] = t0;
    $[2] = t1;
    $[3] = t2;
    $[4] = t3;
    $[5] = t4;
    $[6] = t5;
    $[7] = t6;
    $[8] = t7;
    $[9] = t8;
    $[10] = t9;
  } else {
    t6 = $[7];
    t7 = $[8];
    t8 = $[9];
    t9 = $[10];
  }
  let t10;
  if ($[11] !== t6) {
    t10 = {
      items: t6
    };
    $[11] = t6;
    $[12] = t10;
  } else {
    t10 = $[12];
  }
  let t11;
  if ($[13] !== t10 || $[14] !== t7 || $[15] !== t8 || $[16] !== t9) {
    t11 = {
      ...t7,
      passthroughProps: t8,
      LinkComponent: t9,
      ntExperiencesCollection: t10
    };
    $[13] = t10;
    $[14] = t7;
    $[15] = t8;
    $[16] = t9;
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  const formattedData = t11;
  const t12 = formattedData?.contentfulId;
  let t13;
  if ($[18] !== formattedData || $[19] !== t12) {
    t13 = <PersonalizationExperience id={t12} value={formattedData} BaselineComponent={SiteNavMobileCategory} />;
    $[18] = formattedData;
    $[19] = t12;
    $[20] = t13;
  } else {
    t13 = $[20];
  }
  return t13;
};
export default PersonalizedMobileNavigationCategory;
const formattedNavCategoryExperiences = (experiences: any, passthroughProps: any) => {
  // this feels horrible having to do this, but the Personalization API forwards the Baseline component with
  // props directly without allowing for any client-side formatting such as URL formatters.
  // This custom formatter allows the proper formatted data + event handlers/state to pass in with the variant

  if (!experiences?.length) return null;
  return experiences?.map((exp: any) => ({
    ...exp,
    contentfulId: exp?.id,
    id: exp?.id,
    passthroughProps: passthroughProps,
    ntVariantsCollection: {
      items: exp?.ntVariantsCollection?.items?.map((variant: any) => ({
        ...variant,
        LinkComponent: Link,
        passthroughProps: passthroughProps
      }))
    }
  }));
};